import { defineComponent as _defineComponent } from 'vue'
import { Customer } from '@/models/tenant';
import TimezonesSelect from '@/components/inputs/TimezonesSelect.vue';
import CurrencyCodesSelect from '@/components/inputs/CurrencyCodesSelect.vue';
import MeasurementsSelect from '@/components/inputs/MeasurementsSelect.vue';
import SubsidiariesSelect from '@/components/inputs/SubsidiariesSelect.vue';
import CustomerSourcesSelect from '@/components/inputs/CustomerSourcesSelect.vue';
import RequiredFieldsHint from '@/components/forms/RequiredFieldsHint.vue';
import { useI18n } from '@/composables/i18n';
import useVuelidate from '@vuelidate/core';
import {
  email,
  maxLength,
  optional,
  required,
  requiredIf,
  withLocalizedValidators,
} from '@/utils/validation';
import { computed } from 'vue';
import { hasCurrentUserPermission } from '@/utils/permissionUtils';
import { UserType } from '@/models/userType';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerForm',
  props: {
    value: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: Customer;
};





const { t } = useI18n();

const validationRules = {
  name: withLocalizedValidators('tenant.tenant_name', {
    required,
    maxLength: maxLength(256),
  }),
  subsidiaryId: withLocalizedValidators('inputs.subsidiaries_select.label', {
    required,
  }),
  email: withLocalizedValidators('tenant.email', {
    maxLength: maxLength(256),
    email,
  }),
  foreName: withLocalizedValidators('tenant.foreName', {
    maxLength: maxLength(256),
  }),
  lastName: withLocalizedValidators('tenant.lastName', {
    maxLength: maxLength(256),
  }),
  sapNumber: withLocalizedValidators('tenant.sapNumber', {
    required,
    maxLength: maxLength(256),
  }),
  currencyCode: withLocalizedValidators('inputs.currencycodes_select.label', {
    required,
  }),
  measurement: withLocalizedValidators('inputs.measurements_select.label', {
    required,
  }),
  timeZone: withLocalizedValidators('inputs.timezones_select.label', {
    required,
  }),
  bystronicOrderNumber: withLocalizedValidators('tenant.bystronicOrderNumber', {
    required: requiredIf(() => areRequiredBystronicOrderFields.value),
    maxLength: optional(maxLength(1024)),
  }),
  bystronicOrderPerson: withLocalizedValidators('tenant.bystronicOrderPerson', {
    required: requiredIf(() => areRequiredBystronicOrderFields.value),
    maxLength: optional(maxLength(1024)),
  }),
  customerOrderNumber: withLocalizedValidators('tenant.customerOrderNumber', {
    maxLength: maxLength(1024),
  }),
  customerOrderPerson: withLocalizedValidators('tenant.customerOrderPerson', {
    maxLength: maxLength(1024),
  }),
};

const v$ = useVuelidate(validationRules, props.value);

function getErrorMessage(key: keyof typeof props.value): string | undefined {
  return v$.value[key].$errors?.[0]?.$message;
}

const isEdit = computed<boolean>(() => props.value.id !== 0);

const canEditCustomer = computed<boolean>(() =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

const isDisabledInput = computed<boolean>(
  () => isEdit.value && !canEditCustomer.value,
);

const areRequiredBystronicOrderFields = computed<boolean>(
  () => props.value.hasDatahub || props.value.hasSmbs,
);

return { __sfc: true,props, emit, t, validationRules, v$, getErrorMessage, isEdit, canEditCustomer, isDisabledInput, areRequiredBystronicOrderFields, TimezonesSelect, CurrencyCodesSelect, MeasurementsSelect, SubsidiariesSelect, CustomerSourcesSelect, RequiredFieldsHint, email }
}

})